<template>
  <div id="addViewSiteDocument">
    <b-container fluid :class="{ shrink: selectedDocumentId }" class="pl-30 pt-32 pb-30">
      <div v-if="fromAdmin" class="site-name">
        {{ siteDetails.name }}
        <div class="site-id-info">Site ID: {{ siteDetails.userSiteId }}</div>
      </div>
      <div class="info-container display-inline-flex" v-if="!canSiteDataLockAccess && !user.readOnly">
        <div class="upload-information">
          <span>Upload and manage documents for all participants within this site.</span>
          <span>
            <b-popover id="upload-info-popup" custom-class="my-popover-class" target="upload-info-popover" triggers="click blur">
              <div class="upload-info-content">
                Documents activated here will be visible to all of the site’s participants within the profile. Documents deactivated here will be removed from all participant profile pages and apps, unless already signed. Source documents should not be uploaded here. All source documents should be uploaded within the participant profile page.
              </div>
            </b-popover>
            <i class="fa fa-info-circle" aria-hidden="true" tabindex="0" id="upload-info-popover"></i>
          </span>
          <div class="fw-bold">
            Note: All source documents should be uploaded within the participant profile page.
          </div>
        </div>
        <div class="max-file-size">Max file size: 10mb</div>
        <div class="w-248 text-right">
          <div class="page-size-section">
            <select v-model="pageSize" @change="showSiteDocuments" class="input-bg select_control fs-12">
              <option :value="option.value" v-for="option in documnetListOptions" :key="option.value">{{ option.text }}</option>
            </select>
          </div>
          <button @click="addDocument" v-if="(!canStudyManagerAccess && canSiteTeamAddDocuments) || canStudyAdminAccess" class="btn newBtn ml-13">
            Add Document
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12 pb-20 pl-0 pr-0">
          <div class="table-column">
            <div ref="tableWrapper" class="wrapper height-500 position-relative">
              <table class="table pb-20 mb-50">
                <thead class="table-border fs-12">
                  <tr>
                    <th :class="field.class" v-for="(field, index) in documentListFields" :key="index">
                      <span class="pr-3 position-relative" v-if="field.key == 'action' || field.key == 'configure' || field.key == 'download'">
                        <span>{{ field.label }}</span>
                      </span>
                      <span class="pr-3 position-relative" v-else>
                        <span @click="sortField(field)"
                          >{{ field.label }}
                          <span class="sortUp" :class="{ 'disable-icon': !field.ascOrder }"><i class="fa fa-angle-up ml-4" aria-hidden="true"></i></span>
                          <span class="sortDown" :class="{ 'disable-icon': !field.descOrder }"><i class="fa fa-angle-down ml-4" aria-hidden="true"></i></span>
                        </span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="documents && documents.length > 0">
                  <tr v-for="(document, index) in documents" :key="index" class="border-bottom">
                    <td class="table-content-color w-225 pl-21 doc-name">
                      <span v-if="document.documentType == 'INFORMED_CONSENT' && document.documentType != undefined && document.documentType != null">
                        <span v-if="isStudyAdmin && canConfigureDocument">
                          <router-link
                            :class="{
                              linkDisabled: document.status === 'Processing'
                            }"
                            v-if="document.documentName.length >= 22"
                            tag="a"
                            :to="{
                              name: 'configure-document',
                              params: { documentId: document.docId },
                              query: { siteId: siteId }
                            }"
                            :title="document.documentName"
                            class="link"
                            >{{ document.documentName.split(".")[0].slice(0, 20) }}...</router-link
                          >
                          <router-link
                            :class="{
                              linkDisabled: document.status === 'Processing'
                            }"
                            v-else
                            tag="a"
                            :to="{
                              name: 'configure-document',
                              params: { documentId: document.docId },
                              query: { siteId: siteId }
                            }"
                            :title="document.documentName"
                            class="link"
                            >{{ document.documentName.split(".")[0] }}</router-link
                          >
                        </span>
                        <span v-else>
                          <router-link
                            :class="[
                              {
                                linkDisabled: document.status === 'Processing'
                              },
                              {
                                'no-click': !canSiteTeamAddDocuments && !canStudyAdminAccess
                              }
                            ]"
                            v-if="document.documentName.length >= 22"
                            tag="span"
                            to="#"
                            :title="document.documentName"
                            class="link"
                            >{{ document.documentName.split(".")[0].slice(0, 20) }}...</router-link
                          >
                          <router-link
                            :class="[
                              {
                                linkDisabled: document.status === 'Processing'
                              },
                              {
                                'no-click': !canSiteTeamAddDocuments && !canStudyAdminAccess
                              }
                            ]"
                            v-else
                            tag="span"
                            to="#"
                            :title="document.documentName"
                            class="link"
                            >{{ document.documentName.split(".")[0] }}</router-link
                          >
                        </span>
                      </span>
                      <span v-else-if="canConfigureDocument">
                        <router-link
                          :class="[
                            { linkDisabled: document.status === 'Processing' },
                            {
                              'no-click': !canSiteTeamAddDocuments && !canStudyAdminAccess
                            }
                          ]"
                          v-if="document.documentName.length >= 22"
                          tag="a"
                          :to="{
                            name: 'configure-document',
                            params: { documentId: document.docId },
                            query: { siteId: siteId }
                          }"
                          :title="document.documentName"
                          class="link"
                          >{{ document.documentName.split(".")[0].slice(0, 20) }}...</router-link
                        >
                        <router-link
                          :class="[
                            { linkDisabled: document.status === 'Processing' },
                            {
                              'no-click': !canSiteTeamAddDocuments && !canStudyAdminAccess
                            }
                          ]"
                          v-else
                          tag="a"
                          :to="{
                            name: 'configure-document',
                            params: { documentId: document.docId },
                            query: { siteId: siteId }
                          }"
                          :title="document.documentName"
                          class="link"
                          >{{ document.documentName.split(".")[0] }}</router-link
                        >
                      </span>
                      <span v-else>
                        <router-link
                          :class="[
                            { linkDisabled: document.status === 'Processing' },
                            {
                              'no-click': !canSiteTeamAddDocuments && !canStudyAdminAccess
                            }
                          ]"
                          v-if="document.documentName.length >= 22"
                          tag="span"
                          to="#"
                          :title="document.documentName"
                          class="link"
                          >{{ document.documentName.split(".")[0].slice(0, 20) }}...</router-link
                        >
                        <router-link
                          :class="[
                            { linkDisabled: document.status === 'Processing' },
                            {
                              'no-click': !canSiteTeamAddDocuments && !canStudyAdminAccess
                            }
                          ]"
                          v-else
                          tag="span"
                          to="#"
                          :title="document.documentName"
                          class="link"
                          >{{ document.documentName.split(".")[0] }}</router-link
                        >
                      </span>

                      <span @click="documentPreview(document.configuredDocumentS3Url)" class="ml-5 "><img src="static/img/quick-view.png" class="quick-view-icon"/></span>
                    </td>
                    <td class="table-content-color w-180" v-if="canSiteTeamAddDocuments || canStudyAdminAccess">
                      {{ document.docLanguageName }}
                    </td>
                    <td class="table-content-color w-200 time-stamp">
                      {{ document.uploadedTime | formatDateUTC }} UTC
                      <span class="clock" :id="document.uploadedTime" tabindex="0"></span>
                      <b-popover :target="document.uploadedTime" triggers="click blur">
                        <template v-slot:content>
                          <div class="pop-over-content">
                            <span class="clinic"></span>
                            <div class="ml-20 text-uppercase" v-html="toUserLocalTime(document.uploadedTime)"></div>
                          </div>
                        </template>
                      </b-popover>
                    </td>
                    <td class="table-content-color w-170" v-if="canSiteTeamAddDocuments || canStudyAdminAccess">
                      {{ document.uploadedBy }}
                    </td>
                    <td class="table-content-color w-200 time-stamp">
                      <span v-if="document.activatedTime"
                        >{{ document.activatedTime | formatDateUTC }} UTC
                        <span class="clock" :id="document.activatedTime" tabindex="0"></span>
                        <b-popover :target="document.activatedTime" triggers="click blur">
                          <template v-slot:content>
                            <div class="pop-over-content">
                              <span class="clinic"></span>
                              <div class="ml-20 text-uppercase" v-html="toUserLocalTime(document.activatedTime)"></div>
                            </div>
                          </template>
                        </b-popover>
                      </span>
                    </td>
                    <td class="table-content-color w-170" v-if="canSiteTeamAddDocuments || canStudyAdminAccess">
                      <span v-if="document.activatedBy">{{ document.activatedBy }}</span>
                    </td>
                    <td class="table-content-color w-120">
                      {{ document.status }}
                      <span v-if="document.countForRemainingParticipant && document.status == 'Active' && document.activatedForParticipants" class="badge badge-primary ml-2 custom-badge-count" v-on:click="openParticipantPanel(document)">{{ document.countForRemainingParticipant }}</span>
                      <span v-else-if="document.status == 'Active'" class="badge badge-primary ml-2">ALL</span>
                    </td>
                    <td class="table-content-color w-90 pl-22" v-if="canStudyManagerAccess"></td>
                    <td class="table-content-color w-90 pl-22" v-if="!canStudyManagerAccess">
                      <span v-if="document.documentType == 'INFORMED_CONSENT' && document.documentType != undefined && document.documentType != null">
                        <img v-if="document.configured" src="static/img/green-check.svg" alt="" class="check-icon ml-2" />
                        <router-link
                          v-else-if="isStudyAdmin && canConfigureDocument"
                          :disabled="document.status === 'Processing'"
                          tag="button"
                          :to="{
                            name: 'configure-document',
                            params: { documentId: document.docId },
                            query: { siteId: siteId }
                          }"
                          class="btn btn-outline-primary btn-edit"
                          >Edit</router-link
                        >
                        <button v-else class="btn btn-outline-primary btn-edit disabled">
                          Edit
                        </button>
                      </span>
                      <span v-else>
                        <img v-if="document.configured" src="static/img/green-check.svg" alt="" class="check-icon ml-2" />
                        <router-link
                          v-else-if="(canSiteTeamAddDocuments || canStudyAdminAccess) && canConfigureDocument"
                          tag="button"
                          :to="{
                            name: 'configure-document',
                            params: { documentId: document.docId },
                            query: { siteId: siteId }
                          }"
                          class="btn btn-outline-primary btn-edit"
                          >Edit</router-link
                        >
                      </span>
                    </td>
                    <td class="table-content-color w-110 pl-10" v-if="canSiteTeamAddDocuments || canStudyAdminAccess">
                      <button class="btn btn-outline-primary btn-activate" :disabled="canSiteDataLockAccess || user.readOnly" v-if="document.status == 'Uploaded' && !canStudyManagerAccess" @click="activateDocument(document)">
                        Activate
                      </button>
                      <button class="btn btn-outline-primary" :disabled="canSiteDataLockAccess || user.readOnly" v-if="document.status == 'Active' && !canStudyManagerAccess" @click="dectivateDocument(document)">
                        Deactivate
                      </button>
                    </td>
                    <td class="table-content-color w-80 pl-25">
                      <span class="download-img" @click="getStudyDocuementDownload(document)">
                        <img src="static/img/Download-icon.svg" alt="" />
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else-if="documents && documents.length == 0">
                  <tr>
                    <td>
                      <div class="emptyGrid">
                        <b class="fs-20">No documents available to view</b>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td :colspan="documentListFields.length">
                      <div class="">
                        <div class="stage" :style="{ width: loadingDivWidth }">
                          <div class="dot-stretching"></div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pb-5 pl-15 bottom-0 pagination-container" v-if="documents && documents.length">
              <div class="row display-inline-flex">
                <div @click="prevPage(currentPage, totalPages)" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage <= 1 }">
                  <i class="fa fa-angle-left fs-23 pt-3"></i>
                </div>
                <div class="pagination pt-3">{{ currentPage }}</div>
                <div class="pagination2 pt-3">of {{ totalPages }}</div>
                <div @click="nextPage(currentPage, totalPages)" class="arrow-icon pt-3 cursor_pointer" :class="{ disabledPagination: currentPage >= totalPages }">
                  <i class="fa fa-angle-right fs-23"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
    <!-- Upload Document Modal-->
    <div id="add-document-modal" class="modal fade" role="dialog" data-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content pl-33">
          <div>
            <div class="modal-header border-none">
              <div class="modal-title invite-text">
                Select Document Settings
              </div>
              <button type="button" class="close" @click="closeModal">
                &times;
              </button>
            </div>
            <div class="modal-body pl-0 pr-0">
              <div class="row">
                <span class="ddlLabel">Document Type</span>
                <div class="form-group pt-4" style="margin-bottom: 0px !important;">
                  <div id="progressSelectBox" class="multiselect filter-form-box">
                    <div class="selectBox" @click="showDocumentDropdown">
                      <div class="fakeclass notification-input">
                        <input name="notification" :value="documentType" id="select-question" readonly :tabindex="10" class="form-control input-md th-comman-select-box" />
                      </div>

                      <div class="overSelect"></div>
                    </div>
                    <div id="showDocumentDropdown" class="select-scroll activity-builder-select-options" v-if="isDocumentDrop">
                      <label data-v-2f4812d0="" id="Notification-value" class="pi-width notificationLabel pl-6" v-for="(progress, index) in documentOption" :value="progress.value" :key="index" @click="onDocumentDropClick(progress.value)">
                        {{ progress.name }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-31 ">
                <span class="ddlLabel">Document Language</span>
                <div class="form-group mt-4" style="margin-bottom: 0px !important;">
                  <div id="languageSelectBox" class="multiselect filter-form-box">
                    <div class="selectBox" @click="showLanguageDrop">
                      <div class="fakeclass notification-input">
                        <input name="notification" :value="selectedLang" id="select-question" readonly :tabindex="10" class="form-control input-md th-comman-select-box" />
                      </div>

                      <div class="overSelect"></div>
                    </div>
                    <div
                      id="showLanguageDrop"
                      class="select-scroll activity-builder-select-options"
                      v-if="isLanguageDrop"
                      :class="{
                        showLanguageDropForOneLang: studyLanguages.length == 1
                      }"
                    >
                      <label data-v-2f4812d0="" id="Notification-value" class="pi-width notificationLabel pl-6" v-for="lang in studyLanguages" :value="lang.display_name" :key="lang.language_id" @click="onLanguageDropClick(lang)">
                        {{ lang.display_name }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group footer-btn mt-31">
                <div align-self="center" class="row align-items-center justify-content-center">
                  <div class="pull-right col">
                    <div class="file-upload pull-right create-btn fs-14" v-if="selected && documentType">
                      <input type="file" class="file-input" id="consent_section_doc" v-on:change="onDocFileSelection($event)" accept="application/pdf" />
                      <div class="saveBtn">Save</div>
                    </div>
                    <div class="file-upload pull-right create-btn fs-14" v-if="!selected || !documentType">
                      <input type="text" class="file-input" id="consent_section_doc" v-on:click="languageFile()" accept="application/pdf" />
                      <div class="saveBtn">Save</div>
                    </div>
                    <b-link variant="primary" class="pull-right pt-8 fs-14 pr-20" @click="closeModal()">Cancel</b-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Document preview modal -->
    <documentPreviewModal ref="docPreviewModal" :previewDocument="previewDocument" @resetPreviewDocument="resetPreviewDocument" />
    <!-- Activate Site Document Modal -->
    <activateSiteDocumentModal ref="activateSiteDocument" @assignAllParticipants="assignAllParticipants" @assignGroupOfParticipants="assignGroupOfParticipants" />
    <transition name="slide-fade">
      <div v-show="selectedDocumentId" id="sent-message-right-bar">
        <SendMessagesRightBar :notificationId="selectedDocumentId" :fromComponent="selectedComponentName" :studyId="studyId" v-on:closeParticipantRightSidebar="closeSidebar" v-on:activateMoreParticipantsFromRightBar="assignMoreGroupOfParticipants"></SendMessagesRightBar>
      </div>
    </transition>
  </div>
</template>
<script>
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import toastr from "toastr";
import swal from "sweetalert2";
import _ from "lodash";
import FileSaver from "file-saver";
import localStorageService from "@/services/localStorage";
import { SITEDATALOCK, STUDY_MANAGER, STUDY_ADMIN } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import documentPreviewModal from "@/components/configure-document/document-quick-view-modal";
import activateSiteDocumentModal from "@/components/modals/activate-site-document-modal";
import SendMessagesRightBar from "@/components/common/sent-to-participant-list.vue";
import * as PresignedUrlManager from "../services/managing-one-time-presigned-urls";
export default {
  name: "addviewsitedocument",
  data() {
    return {
      studyLanguages: {},
      selected: null,
      selectedLang: null,
      selectedFile: {},
      fromAdmin: this.isAdmin,
      siteDetails: {},
      documents: null,
      currentPage: 1,
      totalPages: 1,
      pageSize: 15,
      sortValue: "",
      sortOrder: "",
      isStudyAdmin: false,
      isLanguageDrop: false,
      documentType: "Choose Type",
      isDocumentDrop: false,
      documentOption: [
        {
          name: "Other",
          value: "Other"
        }
      ],
      documnetListOptions: [
        {
          value: 15,
          text: "Show 15 items"
        },
        {
          value: 30,
          text: "Show 30 items"
        },
        {
          value: 50,
          text: "Show 50 items"
        }
      ],
      headersAscSortFlags: {
        documentName: "",
        docLanguageName: "",
        uploadedTime: "",
        uploadedBy: "",
        activatedTime: "",
        activatedBy: "",
        status: ""
      },
      documentListFields: [
        {
          key: "documentName",
          type: "string",
          ascOrder: false,
          descOrder: false,
          label: "Name",
          class: "heading-color w-225 cursor_pointer pl-21",
          currentOrder: null
        },
        {
          key: "docLanguageName",
          type: "string",
          ascOrder: false,
          descOrder: false,
          label: "Language",
          class: "heading-color w-180 cursor_pointer pl-10",
          currentOrder: null
        },
        {
          key: "uploadedTime",
          type: "string",
          label: "Uploaded",
          class: "heading-color w-200 cursor_pointer pl-10",
          ascOrder: false,
          descOrder: false,
          currentOrder: null
        },
        {
          key: "uploadedBy",
          type: "string",
          label: "By",
          class: "heading-color w-170 cursor_pointer pl-10",
          ascOrder: false,
          descOrder: false,
          currentOrder: null
        },
        {
          key: "activatedTime",
          type: "string",
          label: "Activated",
          ascOrder: false,
          descOrder: false,
          class: "heading-color w-200 cursor_pointer pl-10",
          currentOrder: null
        },
        {
          key: "activatedBy",
          type: "integer",
          label: "By",
          ascOrder: false,
          descOrder: false,
          class: "heading-color w-170 cursor_pointer pl-10",
          currentOrder: null
        },
        {
          key: "status",
          type: "integer",
          label: "Status",
          ascOrder: false,
          descOrder: false,
          class: "heading-color w-80 cursor_pointer pl-10",
          currentOrder: null
        },
        {
          label: "Configure",
          key: "configure",
          class: "heading-color w-90 cursor_pointer pl-22",
          currentOrder: null
        },
        {
          label: "Action",
          key: "action",
          class: "heading-color w-110 cursor_pointer pl-10",
          currentOrder: null
        },
        {
          label: "Download",
          key: "download",
          class: "heading-color w-80 pl-10"
        }
      ],
      selectedDocumentData: {},
      selectedDocumentId: null,
      selectedComponentName: "",
      studyId: this.$route.params.studyId,
      previewDocument: null,
      tableWrapperWidth: null,
      canSiteTeamAddDocuments: true,
      documentListInterval: null,
      toggleFeatures: []
    };
  },
  props: ["siteId", "isAdmin"],
  computed: {
    ...mapGetters(["user"]),
    sortedDocuments: {
      get: function() {
        return this.updatedDocumentSort();
      },
      set: function() {}
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    loadingDivWidth() {
      return this.tableWrapperWidth + "px";
    },
    canConfigureDocument() {
      //check site country and study flag
      const isESignEnabled = _.find(this.toggleFeatures, {
        featureKey: "ElectronicSignature",
        enabled: true
      });

      const countryDenmarkIndex = _.findIndex(this.siteDetails.countryList, {
        countryName: "Denmark"
      });
      if (isESignEnabled !== undefined && countryDenmarkIndex !== -1) {
        return false;
      } else {
        return true;
      }
    }
  },
  components: {
    documentPreviewModal,
    activateSiteDocumentModal,
    SendMessagesRightBar
  },
  mounted() {
    if (this.user.userRole == "StudyAdmin") {
      this.isStudyAdmin = true;
      this.documentOption = [
        {
          name: "Informed Consents",
          value: "Informed Consents"
        },
        {
          name: "Other",
          value: "Other"
        }
      ];
    } else {
      this.isStudyAdmin = false;
    }
    this.getStudyLanguages();
    this.getSiteInfo();
    this.getStudyCustomDocuements(this.currentPage);
    window.$('[data-toggle="popover"]').popover();
    this.tableWrapperWidth = this.$refs.tableWrapper.clientWidth;

    if (this.user.userRole == "StudyAdmin") {
      this.isStudyAdmin = true;
    } else {
      this.isStudyAdmin = false;
    }
  },
  created() {
    this.getToggledFeatures();
  },
  beforeDestroy() {
    clearInterval(this.documentListInterval);
  },
  watch: {
    documentType() {
      this.documentType;
    },
    selected() {
      if (this.selected) {
        this.selected;
      }
    }
  },
  filters: {
    formatDateUTC(value) {
      // We create the Date obj with moment because the native new Date()
      // does not work on Safari with the date format we receive from backend.
      if (value) {
        const date = moment(value, "YYYY-MM-DD HH:mm:ss").toDate();
        return momentTimeZone(date).format("MMM DD, YYYY hh:mm A");
      }
    }
  },
  methods: {
    updatedDocumentSort() {
      return this.documents.sort((a, b) => new Date(b.uploadedTime) - new Date(a.uploadedTime));
    },
    getSiteInfo() {
      this.$api.getSiteDetailsFact(this.studyId, this.siteId).then(response => {
        this.siteDetails = response.body;
        if (response.body) {
          this.canSiteTeamAddDocuments = response.body.canSiteTeamAddDocuments;
          if (this.canSiteTeamAddDocuments == false && !this.canStudyAdminAccess) {
            this.documentListFields = this.documentListFields.filter(function(obj) {
              return obj.key !== "action" && obj.key !== "docLanguageName" && obj.key !== "uploadedBy" && obj.key !== "activatedBy";
            });
          }
        }
      });
    },
    showDocumentDropdown() {
      this.isDocumentDrop = !this.isDocumentDrop;
    },
    showLanguageDrop() {
      this.isLanguageDrop = !this.isLanguageDrop;
    },
    onDocumentDropClick(IP) {
      this.documentType = IP;
      const v = document.getElementById("showDocumentDropdown");
      v.style.display = "none";
    },
    onLanguageDropClick(I) {
      this.selectedLang = I.display_name;
      this.selected = I.language_id;
      const vi = document.getElementById("showLanguageDrop");
      vi.style.display = "none";
    },
    getStudyCustomDocuements(currentPage, loader = true) {
      if (loader) {
        nprogress.start();
      }
      let siteId;
      if (!this.isAdmin && !this.isStudyAdmin) {
        const user = localStorageService.getItem("userObj");
        siteId = user.siteIds[0];
      } else {
        siteId = this.siteId || this.$route.params.siteId;
      }

      this.$api.getStudyCustomDocuements(this.studyId, siteId, currentPage, this.pageSize, this.sortValue, this.sortOrder).then(
        response => {
          this.documents = [];
          if (!_.isEmpty(response.body)) {
            this.documents = response.body.documents;
            const checkStatusProcessing = this.documents.filter(data => {
              return data.status === "Processing";
            });
            if (checkStatusProcessing.length > 0) {
              this.$store.commit("SHOW_LOADER", !!loader);
              setTimeout(() => {
                this.getStudyCustomDocuements(this.currentPage, false);
              }, 3000);
            } else {
              this.$store.commit("SHOW_LOADER", false);
            }
            this.currentPage = response.body.currentPage;
            this.totalPages = response.body.totalPages;
          }
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting documents.");
        }
      );
    },
    getStudyDocuementDownload(document) {
      const self = this;
      this.$api.getStudyDocuementDownload(document.studyId, document.docId).then(response => {
        const pdfUrl = response.body;
        self.downloadFile(pdfUrl, document.documentName);
      });
    },
    downloadFile(dataURL, filename) {
      const oReq = new XMLHttpRequest();
      const URLToPDF = dataURL;
      oReq.open("GET", URLToPDF, true);
      oReq.responseType = "blob";
      oReq.onload = function() {
        const file = new Blob([oReq.response], {
          type: "application/pdf"
        });
        FileSaver.saveAs(file, filename);
      };
      oReq.send();
    },
    addDocument() {
      clearInterval(this.documentListInterval);
      window.$("#add-document-modal").modal("show");
      this.$forceUpdate();
    },
    getStudyLanguages() {
      this.$api.getStudyLanguages(this.studyId).then(
        response => {
          this.studyLanguages = response.body;
          if (this.studyLanguages.length > 1) {
            this.selected = null;
            this.selectedLang = "Choose Language";
          } else if (this.studyLanguages != null && this.studyLanguages.length == 1) {
            this.selected = this.studyLanguages[0].language_id;
            this.selectedLang = this.studyLanguages[0].display_name;
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting Study Languages.");
        }
      );
    },
    closeModal() {
      this.$swal({
        title: "Are you sure you want to cancel?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "No",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.hideModel();
          this.documentType = "Choose Type";
        }
      });
    },
    languageFile() {
      if (this.documentType == "Choose Type") {
        toastr.error("Please select a document type.");
        return;
      }
      const languageId = this.selected;
      if (!languageId || languageId === undefined) {
        toastr.error("Please select a document language.");
        return;
      }
      const file = event.srcElement.files[0];
      if (!file || file === undefined) {
        toastr.error("No file selected!!");
        return;
      }
    },
    onDocFileSelection(event) {
      if (this.documentType == "Informed Consents") {
        this.documentType = "INFORMED_CONSENT";
      }
      if (this.selected == this.studyLanguages[0].display_name) {
        this.selected = this.studyLanguages[0].language_id;
      }

      if (!this.documentType || this.documentType == "Choose Type" || this.documentType === undefined || this.documentType === "" || this.documentType === "null") {
        this.$toastr.error("Please select a document type.");
        this.hideModel();
        window.$("#add-document-modal").modal("hide");
        return;
      }

      const languageId = this.selected;
      if (!languageId || languageId === undefined) {
        toastr.error("Please select a document language.");
        return;
      }
      const file = event.srcElement.files[0];
      if (!file || file === undefined) {
        toastr.error("No file selected!!");
        return;
      }
      nprogress.start();
      let error = false;
      if (!(event.srcElement || (event.srcElement.files && event.srcElement.files[0] == null))) {
        nprogress.done();
        return true;
      }

      const ext = file.name
        .split(".")
        .pop()
        .toLowerCase();

      const fileName = file.name;

      if (ext != "pdf") {
        error = true;
        toastr.error("PDF files only");
        return;
      }

      if (file) {
        const fileSizeMB = this.formatBytes(file.size);
        if (fileSizeMB > 10) {
          error = true;
          toastr.error("File size cannot exceed 10 MB.");
          this.hideModel("fileSize");
          return;
        }
      }

      if (error) {
        if (this.studyLanguages.length > 1) {
          this.selected = null;
        } else if (this.studyLanguages != null && this.studyLanguages.length == 1) {
          this.selected = this.studyLanguages[0].language_id;
        }
        return;
      }

      const studyId = this.studyId;
      const siteId = this.siteId;
      const fd = new FormData();
      fd.append("file", file);
      fd.append("studyId", studyId);
      fd.append("documentName", fileName);
      fd.append("siteId", siteId);
      fd.append("languageId", this.selected);
      fd.append("documentType", this.documentType);

      const self = this;
      this.$api.saveStudyCustomDocuement(studyId, fd).then(
        () => {
          nprogress.done();
          this.getStudyCustomDocuements(self.currentPage);
          toastr.success("Document uploaded successfully");
          this.documentListInterval = window.setInterval(() => {
            this.getStudyCustomDocuements(this.currentPage);
          }, 6000);
        },
        error => {
          nprogress.done();
          toastr.error(error.body ? error.body.message : "Error while adding the research site document");
        }
      );

      event.target.value = null;
      this.hideModel();
    },
    hideModel(type) {
      if (this.studyLanguages != null && this.studyLanguages.length > 1) {
        this.selected = null;
        this.selectedLang = "Choose Language";
      } else if (this.studyLanguages != null && this.studyLanguages.length == 1) {
        this.selected = this.studyLanguages[0].language_id;
        this.selectedLang = this.studyLanguages[0].display_name;
      }
      if (type !== "fileSize") {
        window.$("#add-document-modal").modal("hide");
      }
      const v = document.getElementById("showDocumentDropdown");
      v.style.display = "none";
      const vi = document.getElementById("showLanguageDrop");
      vi.style.display = "none";
      this.$forceUpdate();
    },
    formatBytes(size) {
      return size / Math.pow(1024, 2);
    },
    activateDocument(document) {
      this.$refs.activateSiteDocument.show();
      this.selectedDocumentData = document;
      return;
    },
    dectivateDocument(document) {
      swal
        .fire({
          title: "Deactivate document?<br><br>Deactivating removes document from Participant's profile and app, unless signed.<br>Are you sure you want to deactivate this document?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4a4a4a",
          cancelButtonColor: "#1e8fe1",
          confirmButtonText: "No",
          cancelButtonText: "Yes"
        })
        .then(({ dismiss }) => {
          if (dismiss === "cancel") {
            nprogress.start();
            this.$api.statusChangeStudyCustomDocuement(document.studyId, document.docId, false, false, document).then(
              () => {
                this.getStudyCustomDocuements(this.currentPage);
                this.$toastr.success("Document deactivated.");
                nprogress.done();
              },
              error => {
                nprogress.done();
                toastr.error(error.body ? error.body.message : "Error while deactivating document");
              }
            );
          }
        });
    },

    // ------------------------------------------------------------
    // |      Particular Participants and All Participant Selection  |
    // ------------------------------------------------------------
    assignAllParticipants() {
      nprogress.start();
      const document = this.selectedDocumentData;
      this.$api.statusChangeStudyCustomDocuement(document.studyId, document.docId, false, false, "").then(
        () => {
          this.$toastr.success("Document activated for all site participants.");
          this.getStudyCustomDocuements(this.currentPage);
          nprogress.done();
        },
        error => {
          nprogress.done();
          toastr.error(error.body ? error.body.message : "Error while activating document");
        }
      );
    },
    assignGroupOfParticipants() {
      const document = this.selectedDocumentData;
      const siteId = this.$route.params.siteId;
      if (siteId && document.docId) {
        this.$router.push({
          name: "study-participants-list",
          query: {
            siteDocumentId: document.docId,
            siteId: siteId,
            languageId: document.languageId,
            activateForMoreParticipants: false
          }
        });
      } else {
        this.$router.push({
          name: "study-participants-list",
          query: {
            siteDocumentId: document.docId,
            languageId: document.languageId,
            activateForMoreParticipants: false
          }
        });
      }
    },
    assignMoreGroupOfParticipants() {
      const document = this.selectedDocumentData;
      const siteId = this.$route.params.siteId;
      if (siteId && document.docId) {
        this.$router.push({
          name: "study-participants-list",
          query: {
            siteDocumentId: document.docId,
            siteId: siteId,
            languageId: document.languageId,
            activateForMoreParticipants: true
          }
        });
      } else {
        this.$router.push({
          name: "study-participants-list",
          query: {
            siteDocumentId: document.docId,
            languageId: document.languageId,
            activateForMoreParticipants: true
          }
        });
      }
    },
    openParticipantPanel(document) {
      this.selectedDocumentData = document;
      this.selectedDocumentId = document.docId;
      this.selectedComponentName = "SITE_DOCUMENT";
    },
    closeSidebar() {
      this.selectedDocumentId = null;
    },
    showSiteDocuments() {
      this.getStudyCustomDocuements(this.currentPage);
    },
    prevPage(currentPage, totalPages) {
      const self = this;
      if (currentPage <= totalPages) {
        const promise = new Promise(function(resolve) {
          const currPage = currentPage - 1;
          resolve(currPage);
        });
        promise.then(function(currentPage) {
          self.getStudyCustomDocuements(currentPage);
        });
      }
    },
    nextPage(currentPage, totalPages) {
      const self = this;
      if (currentPage < totalPages) {
        const promise = new Promise(function(resolve) {
          const currPage = currentPage + 1;
          resolve(currPage);
        });
        promise.then(function(currentPage) {
          self.getStudyCustomDocuements(currentPage);
        });
      }
    },
    sortField(field) {
      let direction;
      field.ascOrder = !field.ascOrder;
      if (field.ascOrder == true) {
        field.ascOrder = true;
        field.descOrder = false;
        direction = "asc";
      } else {
        field.ascOrder = false;
        field.descOrder = true;
        direction = "desc";
      }

      this.sortValue = field.key;
      this.sortOrder = direction;
      this.getStudyCustomDocuements(this.currentPage);
    },
    sortString(direction) {
      let records = _.cloneDeep(this.documents);
      records = _.orderBy(records, [records => records.documentName.toLowerCase()], direction);
      return records;
    },
    sortTimeStamp(direction, field) {
      let records = _.cloneDeep(this.documents);
      records = _.orderBy(records, field.key, direction);
      return records;
    },
    toUserLocalTime(timeString) {
      const localObj = moment.utc(timeString).local();
      const formatedTime = localObj.format("DD MMM YYYY hh:mm");
      const meridiem = localObj.format("A");

      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);

      return `<span>${formatedTime}</span> <span class="fs-12">${meridiem} ${abbr}</span>`;
    },
    async documentPreview(documentURL) {
      this.getRenewedPresignedUrl(documentURL);
      this.$refs.docPreviewModal.show();
    },
    /* To get the renewed signed url for any resource, every time it is opened on UI. */
    async getRenewedPresignedUrl(resource) {
      const tempResource = _.cloneDeep(resource);
      this.previewDocument = null;
      this.previewDocument = await PresignedUrlManager.renewSingleUseTokenForPresignedUrl(tempResource, this);
    },
    resetPreviewDocument() {
      this.previewDocument = null;
    },
    getToggledFeatures() {
      this.$api.getToggleFeaturesFact(this.studyId).then(
        response => {
          if (response.body) {
            this.toggleFeatures = response.body.studyFeatures;
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study features.");
        }
      );
    }
  }
};
</script>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
.header-title {
  font-family: Roboto-Medium;
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.09;
  letter-spacing: normal;
  color: #2d3752;
}
.display-inline-block {
  display: flex;
}
.upload-information {
  font-family: Roboto-Regular;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -0.2;
  color: #4a4a4a;
  min-width: 460px;
  .fa-info-circle {
    color: #959fa4;
    border: none !important;
    outline: none !important;
    cursor: pointer;
  }
}

.disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.disabled-save {
  opacity: 0.65 !important;
  cursor: not-allowed !important;
}

.max-file-size {
  text-align: right;
  font-family: Roboto-Regular;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -0.2;
  color: #4a4a4a;
  margin: 0 7px;
  margin-right: 5px;
  vertical-align: top;
  width: 100%;
}
.newBtn {
  padding: 5px 15px;
  border-radius: 2px;
  color: #fff !important;
  border: solid 1px #508ee1 !important;
  background-color: #508ee1 !important;
  cursor: pointer;
  font-family: Roboto-Bold;
  font-size: 12px !important;
  //line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  //vertical-align: top;
  //margin-top: 6px;
}

.btn-link {
  margin-top: -5px;
}

.button-div {
  margin-top: -10px;
  float: right;
}
.modal-content {
  width: 499px;
}
.modal-title {
  margin: auto;
  margin-top: 45px;
  text-align: center;
  width: 100%;
  font-family: Roboto-Regular;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #666669;
}
.create-btn {
  width: 64px !important;
  height: 36px !important;
  border-radius: 2px !important;
  background-color: #1e8fe1 !important;
  font-family: Roboto-Regular !important;
  font-size: 14px !important;
  font-weight: normal !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.71 !important;
  letter-spacing: normal !important;
  color: #ffffff !important;
}
.ddlLabel {
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.language-select-box {
  margin-top: 12px;
  width: 360px;
  height: 40px;
  border-radius: 3px;
  box-shadow: inset 0 1px 2px 0 #e4e8eb;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  background-image: url(/static/img/arrow-down.png) !important;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}
.file-upload {
  position: relative;
  overflow: hidden;
  border: none;
  border-radius: 3px;
  padding: 5px 10px;
  display: inline;
  background-color: #fff;
  border-radius: 4px;
  border: solid 1px #1e8fe1;
  font-family: Lato-Regular;
  font-size: 13px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  background: #fff;
  color: #1e8fe1;
}

body {
  color: #333;
  .mb-5 {
    margin-bottom: 5px !important;
  }
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.table-striped > tbody > tr[data-v-15e213e8]:nth-of-type(odd) {
  background-color: #fff !important;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.row {
  display: block;
  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.select_section {
  select.form-control {
    height: 40px !important;
    line-height: 22px;
  }
}

.show_section {
  select.form-control {
    height: 36px !important;
    line-height: 22px;
  }
}

.modal-dialog {
  min-width: 31%;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }

  .col-sm-12 {
    width: 100%;
  }

  .col-sm-10 {
    width: 83.33333333%;
  }

  .col-sm-4 {
    width: 33.33333333%;
    //max-width: inherit;
  }

  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }

  .col-md-2 {
    width: 16.66666667%;
  }

  .col-md-10 {
    width: 83.33333333%;
  }

  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }

  .col-lg-2 {
    width: 16.66666667%;
  }

  .col-lg-10 {
    width: 82.33333333%;
  }

  .col-lg-11 {
    width: 91.66666667%;
  }
}

.invite-text {
  color: #666669 !important;
}

.color_f16559 {
  color: #f16559;
}

.height-auto {
  height: auto !important;
}

.table {
  .heading-color {
    color: #9b9b9b !important;
    border-top: none;
    border-bottom: none;
    vertical-align: top;
    //font-family:'Lato', sans-serif;
    padding-top: 6px;
    padding-bottom: 6px;
    background: rgba(249, 249, 251, 0.2);
  }

  th,
  td {
    //font-family: 'Lato', sans-serif;
    padding: 10px;
    // line-height: 30px;
    word-break: break-all;
    border: none;
    vertical-align: middle;

    &.doc-name {
      a {
        font-size: 14px;
        font-weight: bold;
        color: #4c8ce4;
      }
      span {
        font-size: 14px;
        font-weight: bold;
        color: #4c8ce4;
      }
      img {
        &.quick-view-icon {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
      }
    }

    &.time-stamp {
      font-size: 12px;
      .clock {
        display: inline-block;
        width: 17px;
        height: 17px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        vertical-align: middle;
        background-image: url(/static/img/clock-2.png);
        margin-top: -6px;
      }
      .clock:focus {
        outline: none;
      }
    }
  }
}

.table-border {
  border-bottom: 1px solid #e4e8eb !important;
}

.new-label-width {
  min-width: 300px !important;
}

.invite-width {
  min-width: 250px !important;
}

.table-content-color {
  color: #4a4a4a;
  //height: 55px !important;
  .download-img {
    cursor: pointer;
  }
}

.azure-class {
  color: #1f95f2;
}

.modal-content {
  padding: 15px;
}

.table-column {
  // width: 1140px;
  background-color: #fff;
  height: 100%;
  //padding: 18px 0px 0px 0px;
  color: #9b9b9b;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #e4e8eb;
  font-family: "Roboto-Regular", sans-serif;
}

.saveBtn {
  padding: 5px;
  font-family: "Roboto", sans-serif;
}

.color_import {
  color: #34537d;
  padding-bottom: 30px;
}

.input-bg {
  width: 150px;
  background: #ffffff !important;
  color: #4a4a4a !important;
  border: 1px solid #e4e8eb !important;
}

.icon-bg {
  color: #ffffff;
}

.icon-color {
  color: #34537d;
}

.fs-14 {
  font-size: 14px !important;
}

.view-color {
  color: #00b1ff;
  cursor: pointer;
}
.close-style {
  position: relative;
  right: 8px;
  top: 5px;
  font-size: 28px;
}

.color_2d3752 {
  color: #4a4a4a;
}

.document .modal-dialog {
  width: 500px;
}
.select_control {
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  letter-spacing: -0.29px;
}

.gridHead {
  margin-top: -7px;
}

.table .trigger:hover {
  background-color: #e2e8ee;
  border-radius: 3px;
  .edit {
    display: inline;
    top: 8px;
    left: 15px;
  }
}

.table .trigger2:hover {
  background-color: #e2e8ee;
  border-radius: 3px;
  .edit {
    display: inline;
    top: 8px;
    left: 4px;
  }
}

.edit {
  padding: 0px;
  display: none;
  font-size: 16px;
  cursor: pointer;
}

.wrapper {
  overflow-x: auto;
  //Scrollbar CSS for Mozilla
  scrollbar-color: #9b9b9b #e5e5e5; /* thumb and track color */
  scrollbar-width: thin;

  //Below is the scrollbar css for Chrome
  &::-webkit-scrollbar {
    //width: 6px;
    height: 10px;
    background-color: #e5e5e5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #9b9b9b;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #e5e5e5;
  }
}

@media (max-width: 575px) {
  .xs-none {
    display: none;
  }
  .xs-pl-0 {
    padding-left: 0px;
  }
  .mob-pt15 {
    padding-top: 15px;
  }
}

@media (max-width: 1199px) {
  .has-sidemenu .container {
    padding-left: 30px !important;
    padding-right: 30px !important;
    width: auto;
    max-width: inherit;
  }
}

.modal-header {
  padding: 0 !important;
}

.select_section:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  color: #4a4a4a;
  right: 15px;
  top: 10px;
  height: 34px;
  padding: 0px 0px 0px 1px;
  position: absolute;
  pointer-events: none;
}

.show_section:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  color: #4a4a4a;
  right: 25px;
  top: 8px;
  height: 34px;
  padding: 0px 0px 0px 1px;
  position: absolute;
  pointer-events: none;
}

.show_section.siteId:after,
.show_section.country:after,
.show_section.langugage:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  right: 25px;
  top: 8px;
  position: absolute;
}

.lh-36 {
  line-height: 36px;
}

.height-500 {
  min-height: 400px !important;
}

.sortDown {
  position: absolute;
  padding-left: 4px;
  padding-top: 3px;
}

.sortUp {
  position: absolute;
  margin-top: -3px;
  padding-left: 4px;
}

.sortUp,
.sortDown {
  cursor: pointer;
  color: #666769;
  &.disable-icon {
    color: #a8a8a8;
  }
  i {
    font-size: 11px;
  }
}

.line-height {
  line-height: 1.5;
}

.pt-150 {
  padding-top: 150px;
}

.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  //color: #e4e8eb;
}

.arrow-icon:not(.disabledPagination):hover {
  background-color: #e4e8eb;
}

.pagination {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 40px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.disabledPagination {
  pointer-events: none;
  color: #e4e8eb;
}

.display-inline-flex {
  display: inline-flex !important;
}

.position-absolute {
  position: absolute;
}

.bottom-0 {
  bottom: 0px;
}

.form {
  padding: 15px;
}

.file-upload {
  color: #fff !important;
  background-color: #1e8fe1 !important;
  border-color: #1e8fe1 !important;
  position: relative;
  overflow: hidden;
  border: none;
  border-radius: 3px;
  padding: 1px 10px;
  height: 36px;
  border-radius: 4px;
  line-height: 1.33;
  text-align: center;
  align-items: center;
}

.emptyGrid {
  padding-top: 150px;
  height: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
}
.info-msg {
  position: relative;
  left: 10px;
  top: 14px;
}
.help_icon {
  color: #b8c7ce;
  border: none !important;
  outline: none !important;
}
.btn-outline-primary {
  color: #1e8fe1;
  border-color: #1e8fe1;
  font-size: 12px;
  padding: 3px 7px;
  letter-spacing: -0.3px;
  &:hover {
    color: #fff;
  }
  &.btn-activate {
    padding: 3px 14px;
  }
  &.btn-edit {
    padding: 3px 12px;
  }
}

.container-fluid {
  padding-left: 0;
  .site-name {
    font-family: Roboto-Medium;
    font-size: 14px;
    line-height: 1.29;
    color: #4a4a4a;
    margin-top: 10px;
    margin-bottom: 5px;
    .site-id-info {
      font-family: Roboto-Medium;
      font-size: 12px;
      font-weight: 500;
      //margin-top: 5px;
    }
  }
  .info-container {
    padding-bottom: 10px;
    vertical-align: text-bottom;
    width: 100%;
    &.display-inline-flex {
      align-items: center;
    }
  }
  .page-size-section {
    display: inline-block;
    //margin-top: 5px;
    position: relative;
    &:after {
      content: "\F107";
      font: normal normal normal 20px/1 FontAwesome;
      color: #4a4a4a;
      right: 9px;
      top: 5px;
      padding: 0px 0px 0px 1px;
      position: absolute;
      pointer-events: none;
    }
    select {
      border-radius: 2px;
      color: #4a4a4a;
      background-image: none;
      padding: 5px;
      padding-right: 29px;
      padding-left: 7px;
      width: auto;
    }
  }
  .pagination-container {
    width: 100%;
    border-top: 1px solid #e4e8eb;
    padding-top: 5px;
  }
}
.upload-info-content {
  font-family: Roboto-Regular;
  font-size: 12px;
  line-height: 1.33;
  color: #000000;
}
.pop-over-content {
  position: relative;
  color: #4a4a4a;
  font-family: Roboto-Regular;
  font-size: 14px;
  opacity: 0.7;
  div {
    display: inline-block;
  }
  span {
    display: inline-block;
    width: 12px;
    height: 11px;
    background-repeat: no-repeat;
    position: absolute;
    top: 5px;
    &.clinic {
      background-image: url(/static/img/date-clinic-icon.svg);
    }
  }
}
/* IE9, IE10, IE11 */
@media screen and (min-width: 0\0) {
  .w-248 {
    width: 260px !important;
    min-width: 260px !important;
  }
}

.stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 2rem 0;
  overflow: hidden;
  flex-direction: column;
}
</style>
<style lang="scss">
#addViewSiteDocument {
  .shrink {
    width: 71%;
    float: left;
  }
  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
  #sent-message-right-bar {
    width: 30%;
    float: right;
    margin-top: -25px;
    margin-right: -25px;
  }
  .custom-badge-count {
    padding: 3px 10px;
    cursor: pointer;
  }
}
.bs-popover-right {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  .arrow::before {
    border-right-color: #e4e8eb;
  }
}
.popover {
  width: auto !important;
}

.btn-outline-primary:hover {
  color: #45b6f2 !important;
}

//dropdown
.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}
.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
.select-scroll {
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */
}
.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}

#select-question {
  appearance: none !important;
  background-position: right 50% !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/arrow-down.png);
}

.notification-input .th-comman-select-box {
  color: #666669 !important;
  font-size: 15px;
  text-transform: capitalize;
}
.overSelect {
  position: absolute;
  left: 0;
  right: 0;

  bottom: 0;
}
#showNotification {
  position: absolute;
  background: #fff;
  width: 96%;
  height: fit-content;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}
#showNotification label:first-child {
  background-color: #f5f8fa;
}
#showNotification label {
  font-size: 14px;
  color: #000;
  float: left;
  width: 275px;
  line-height: 30px;
  margin-bottom: 0px;
}
.pi-width {
  width: 100% !important;
  padding: 7px 16px !important;
}
#add-document-modal {
  .form-control:disabled,
  .form-control {
    background-color: #ffffff !important;
    opacity: 1;
    width: 96%;
    height: 40px;
  }
}
#showNotification label:hover {
  background-color: #f5f8fa;
}
.footer-btn {
  margin-bottom: 0px;
}

#showDocumentDropdown {
  background: #fff;
  position: absolute;
  top: 0px;
  left: 0;
  width: 96%;
  height: fit-content;
  border-radius: 4px;
  overflow: hidden;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

// #showDocumentDropdown label:first-child {
//   background-color: #f5f8fa;
// }

#showDocumentDropdown label {
  float: left;
  line-height: 30px;
  margin-bottom: 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  color: #666669;
}
#progressSelectBox,
#languageSelectBox {
  position: relative;
}
#showLanguageDrop {
  top: 0px;
  background: #fff;
  position: absolute;
  left: 0;
  width: 96%;
  height: 100px;
  overflow: auto !important;
  border-radius: 4px;
  padding-bottom: 10px;
  overflow: hidden;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}
#showDocumentDropdown label:hover,
#showLanguageDrop label:hover {
  background-color: #f5f8fa;
}

// #showLanguageDrop label:first-child {
//   background-color: #f5f8fa;
// }

#showLanguageDrop label {
  float: left;
  line-height: 30px;
  font-family: Roboto;
  margin-bottom: 0px;
  font-size: 15px;
  font-weight: 500;
  color: #666669;
}
.form-group input:focus,
.form-group .form-control:focus {
  box-shadow: none;
}
.no-click {
  pointer-events: none;
}
.linkDisabled {
  opacity: 0.5;
  pointer-events: none;
}
.showLanguageDropForOneLang {
  height: fit-content !important;
  padding-bottom: 0px !important;
}
</style>
